import { url } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class FetchPostcodeDeliverableStatus {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService;

    /**
     * FindAddressesForPostcode constructor.
     *
     * @param apiService
     */
    constructor(apiService = null) {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Determine whether we can deliver to this postcode via the API.
     *
     * @param {string} postcode
     *
     * @returns {Promise}
     */
    handle(postcode) {
        let apiUrl = url(ApiEndpoints['postcodes.deliverable'], [postcode]);

        return this.apiService
            .get(apiUrl);
    }
}
